"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var embla_carousel_1 = __importDefault(require("embla-carousel"));
var emblaCarouselArrowsButtons_1 = require("./emblaCarouselArrowsButtons");
var emblaCarouselInit = function () {
    var OPTIONS = {
        align: "center",
    };
    var emblaNodes = (Array.from(document.querySelectorAll(".embla")));
    emblaNodes === null || emblaNodes === void 0 ? void 0 : emblaNodes.forEach(function (slider) {
        var viewportNode = slider.querySelector(".embla__viewport");
        var prevBtnNode = (slider.querySelector(".embla__button--prev"));
        var nextBtnNode = (slider.querySelector(".embla__button--next"));
        var controlsNode = (slider.querySelector(".embla__controls"));
        var emblaApi = embla_carousel_1.default(viewportNode, OPTIONS);
        var removePrevNextBtnsClickHandlers = emblaCarouselArrowsButtons_1.addPrevNextBtnsClickHandlers(emblaApi, prevBtnNode, nextBtnNode, controlsNode);
        emblaApi.on("destroy", removePrevNextBtnsClickHandlers);
    });
};
exports.default = emblaCarouselInit;
